// ./RecoverForm.tsx
import React, { FormEvent, useState } from 'react';
import { Col, Form, FormGroup, Input, Label } from 'reactstrap';
import { Btn, H2, P } from '../AbstractElements';
import { EmailAddress } from '../Utils/Constants';
import { postJson } from '../hook/request';
import { toast } from 'react-toastify';

type RecoverFormProps = {
  email?: string;
  onBack?: () => void;
};

export default function RecoverForm({ email = '', onBack }: RecoverFormProps) {
  const [value, setValue] = useState(email);
  const [loading, setLoading] = useState(false);

  const handleRecover = async (e: FormEvent) => {
    e.preventDefault();
    if (!value.trim()) {
      toast.warn('Inserisci una email');
      return;
    }

    try {
      setLoading(true);
      const res = await postJson<any>('/recover/password', { email: value.trim() });
      const payload = (res as any)?.data ?? res;

      if (String(payload?.status).toLowerCase() === 'ok') {
        toast.success(
          payload?.message ||
            'Email di recupero inviata. Controlla la tua casella di posta.'
        );
        onBack && onBack();
      } else {
        toast.error(payload?.message || 'Errore nell’invio dell’email di recupero.');
      }
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          'Errore durante la richiesta di recupero password.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-main">
      <Form className="theme-form" onSubmit={handleRecover}>
        <H2 className="text-center">Recupera password</H2>
        <P className="text-center mt-1">
          Inserisci la tua email: riceverai un link per il reset.
        </P>

        <FormGroup>
          <Col>
            <Label>{EmailAddress}</Label>
          </Col>
          <Input
            type="email"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            required
          />
        </FormGroup>

        <div className="text-end mt-3 d-flex gap-2">
          {onBack && (
            <Btn type="button" style={{color:'black'}} color="light" onClick={onBack}>
              Torna al login
            </Btn>
          )}
          <Btn color="primary" type="submit" disabled={loading}>
            {loading ? 'Invio…' : 'Invia link'}
          </Btn>
        </div>
      </Form>
    </div>
  );
}
